// extracted by mini-css-extract-plugin
module.exports = {"title":"Advantage_title__38I-I","textArea":"Advantage_textArea__2v9sq","counter":"Advantage_counter__2JV7P"};